export default ['tania@foodforjoe.es', 'marcela@foodforjoe.es'];
